<template>
  <div class="ExcelTable" v-html="headsettedTable"></div>
</template>

<script>
export default {
  props: {
    table: {
      type: String,
      default: ''
    }
  },
  computed: {
    headsettedTable() {
      const parser = new DOMParser()
      const table = parser.parseFromString(this.table, "text/xml")
      const rows = table.querySelectorAll('tr')
      const traverseHeadings = (index = 0) => {
        const row = rows[index]
        const cells = row.querySelectorAll('td')
        row.classList.add('ExcelTable__heading')
        for (let i = 0; i < cells.length; i++) {
          const cs = cells[i].getAttribute('colspan')
          const rs = cells[i].getAttribute('rowspan')
          if (cs || rs) {
            return traverseHeadings(index + 1)
          }
        }
      }
      traverseHeadings()
      var tmp = document.createElement('div')
      tmp.appendChild(table.documentElement)
      return tmp.innerHTML
    }
  }
}
</script>

<style>
.ExcelTable {
  /* padding: 16px 26px; */
  position: relative;
}

.ExcelTable table {
  background: #FFF;
  overflow-x: scroll;
  box-shadow: 0 2px 4px 3px rgba(0,0,0,0.2);
  border-collapse: collapse;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.ExcelTable__heading {
  background: #3c4148;
  color: #FFF;
  font-weight: 700;
  font-size: 1em;
}

.ExcelTable td {
  border: 1px solid #bed1c7;
  min-width: 170px;
  padding: 10px 16px;
}

.ExcelTable:hover .ExcelTable__actions {
  opacity: 1;
  transform: scale(1, 1);
}

.ExcelTable__actions {
  bottom: 36px;
  display: flex;
  justify-content: space-between;
  left: 0;
  margin: auto;
  opacity: 0;
  position: absolute;
  right: 0;
  width: 396px;
  transform: scale(0.8, 0.8);
  transition: all 0.2s;
}

.ExcelTable__actions > .StdButton {
  max-width: 190px;
}
</style>




// WEBPACK FOOTER //
// src/components/ExcelTable/ExcelTable.vue